import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

import { ParkingService } from '../lib/parking.service'
import { AutoDTO } from '../lib/parking.types'
import { GET_AUTOS } from './useAutos'

type UpdateAutoParams = {
  id: string
  data: AutoDTO
}

export const useUpdateAuto = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse<null>,
    AxiosError<ServerValidationError>,
    UpdateAutoParams
  >({
    mutationFn: ({ id, data }) => ParkingService.updateAuto(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [GET_AUTOS] })
  })
}
